import axios from 'axios';
import {
    PUSH_NOTIFICATION,
    ACTION_NOTIFICATION,
    DELETE_COUNTRY_URL,
    STATE_COUNTRY_URL,
    ADD_COUNTRY_LIST_URL,
    ADD_ADMIN_USER_URL,
    DELETE_ADMIN_URL,
    EDIT_ADMIN_USER_URL,
    EDIT_AGENT_USER_URL,
    ADD_AGENT_USER_URL,
    DELETE_AGENT_URL,
    GET_COUNTRY_DATA,
    GET_CATEGORY_DATA
} from '../api';
import errorHandler from "../utils/errorHandler";

export const sendPushNotification = (data) => {
    return axios.post(PUSH_NOTIFICATION, {
        topic: data.topic,
        title: data.title,
        raw_message: data.raw_message
    }).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            error: true
        }
    });
};

export const actionNotification = (data) => {
    return axios.post(ACTION_NOTIFICATION, {data}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            error: true
        }
    });
}

export const deleteCountry = (id) => {
    return axios.post(DELETE_COUNTRY_URL, {id}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            error: true
        }
    });
};

export const getCountryData = () => {
    return axios.get(GET_COUNTRY_DATA).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            error: true
        }
    });
};

export const getCategory = () => {
    return axios.get(GET_CATEGORY_DATA).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            error: true
        }
    });
};

export const stateCountry = (id, state) => {
    return axios.post(STATE_COUNTRY_URL, {id, state}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            error: true
        }
    });
};

export const addAdminUser = (data) => {
    return axios.post(ADD_ADMIN_USER_URL, {data}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        return {
            data: error,
            error: true
        }
    });
};

export const editAdminUser = (data) => {
    return axios.post(EDIT_ADMIN_USER_URL, {data}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        return {
            data: error,
            error: true
        }
    });
}

export const addAgentUser = (data) => {
    return axios.post(ADD_AGENT_USER_URL, {data}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        return {
            data: error,
            error: true
        }
    });
};

export const editAgentUser = (data) => {
    return axios.post(EDIT_AGENT_USER_URL, {data}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        return {
            data: error,
            error: true
        }
    });
}

export const deleteAgent = (id) => {
    return axios.post(DELETE_AGENT_URL, {id}).then((response) => {
        return {
            data: response.data,
            error: false
        }
    }).catch((err) => {
        return {
            data: err.response.data.error,
            error: true
        }
    });
};

export const deleteAmin = (id) => {
    return axios.post(DELETE_ADMIN_URL, {id}).then((response) => {
        return {
            data: response.data,
            error: false
        }
    }).catch((err) => {
        return {
            data: err.response.data.error,
            error: true
        }
    });
};

export const addCountry = (data, checked) => {
    return axios.post(ADD_COUNTRY_LIST_URL, {data, checked}).then((response) => {
        return {
            data: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            error: true
        }
    });
};
